<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-toolbar>
    <add-slide-form :data="values" @data-dialog="onData" />
    <v-card-actions>
      <v-spacer />
      <v-btn depressed @click="$emit('close')">
        Close
      </v-btn>
      <v-btn :disabled="canSubmit === false" :loading="isLoading" depressed @click="submit">
        Create
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import AddSlideForm from '@/components/dialogs/forms/AddSlideForm';
import { CREATE_SLIDE } from '@/config/constants';

export default {
  name: 'ChildSlideDialog',
  components: { AddSlideForm },
  props: {
    type: String,
    parentId: String,
    title: String,
    documentKey: String
  },
  data() {
    return {
      canSubmit: false,
      values: {},
      isLoading: false
    };
  },
  watch: {
    values: {
      handler(values) {
        if (!values.name) return;
        if (values.name.length > 0) {
          this.shouldSubmit();
        }
      },
      deep: true
    }
  },
  methods: {
    submit() {
      this.isLoading = true;
      this.$store
        .dispatch(CREATE_SLIDE, { parents: [this.parentId], ...this.values, type: this.type })
        .then(res => {
          this.values = {};
          this.canSubmit = false;
          this.isLoading = false;
          this.$emit('close');
        })
        .catch(err => {
          this.isLoading = false;
          this.$emit('close');
        });
    },
    onData(e, v) {
      this.values = e;
    },
    shouldSubmit(e, v) {
      this.canSubmit = true;
    }
  }
};
</script>

<style scoped></style>
